module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0112.jpg?v=224b588e";